export default [{
    path: '/job',
    name: 'job',
    component: () => import('@/views/job')
},
{
    path: '/job/add',
    component: () => import('@/views/job/add')
},
{
    path: '/job/:id',
    props: (route) => ({
        id:  Number(route.params.id)
    }),
    component: () => import('@/views/job/detail')
},
{
    path: '/job/:id/edit',
    props: (route) => ({
        id:  Number(route.params.id)
    }),
    component: () => import('@/views/job/edit')
},
    {
        path: '/job/:id/copy',
        props: (route) => ({
            id:  Number(route.params.id)
        }),
        component: () => import('@/views/job/copy')
    },
]